import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, getOrganisationBaseUrl } from "frame";
import fromTypes from "../actions/types";
import { onAddFailed, onAddSuccess } from "../actions";

const staffAddEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.STAFF_SAVE_CLICKED),
		mergeMap(() => {
			const currentStaff = state$.value.staff.currentStaff;
			const organisationBaseUrl = getOrganisationBaseUrl(state$.value);
			const pendingPassword = currentStaff.password;
			const staffId = currentStaff.id;
			const isNew = state$.value.staff.isNew;

			return ajax
				.post(
					`${organisationBaseUrl}/staff/createorupdate`,
					{
						id: currentStaff.id,
						organisationId: currentStaff.organisationId,
						firstName: currentStaff.firstName,
						lastName: currentStaff.lastName,
						email: currentStaff.email,
						phoneNumber: currentStaff.phoneNumber,
						emailInvitation: currentStaff.emailInvitation,
						status: currentStaff.status,
						staffIdNumber: currentStaff.staffIdNumber,
						supervisor: currentStaff.supervisor,
						notes: currentStaff.notes,
						organisationRole: currentStaff.organisationRole,
						attachments: currentStaff.attachments,
					// Send null (not "") for nullable Guid fields — ASP.NET Core's
					// System.Text.Json rejects empty strings for Guid? deserialization.
					organisationStaffTypeId:
						currentStaff.organisationStaffTypeId || null,
						organisationStaffTypesStaffType:
							currentStaff.organisationStaffTypesStaffType,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) => {
						if (pendingPassword && staffId && !isNew) {
							return ajax
								.post(
									`${organisationBaseUrl}/staff/${staffId}/set-password`,
									{ password: pendingPassword },
									authHeaders()
								)
								.pipe(
									mergeMap(() =>
										of(onAddSuccess(ajaxResponse.response))
									),
									catchError(() =>
										of(onAddSuccess(ajaxResponse.response))
									)
								);
						}
						return of(onAddSuccess(ajaxResponse.response));
					}),
					catchError((error) => of(onAddFailed(error)))
				);
		})
	);

export default staffAddEffect;
